import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const useValidateSessionStorage = (
  key: string,
  redirectPath: string,
  redirect?: boolean
) => {
  const navigate = useNavigate();

  useEffect(() => {
    const selectedValues = sessionStorage.getItem(key);

    if ((selectedValues === "{}" || !selectedValues) && redirect) {
      navigate(redirectPath);
    }
  }, [key, navigate, redirectPath]);
};
